<template lang="pug">
.message-item-container
  span.time {{ formatedTime }}
  .message-item
    .message-header
      i.ic_svip
      span.title {{ content.title || '' }}
      .outlink(@click="goToOutlink(content.redirectUrl)" v-if="content.redirectUrl")
        span.color_text_vip_1 {{ content.redirectTitle || '' }}
        i.ic_arrow
    .message-content
      p.color_text_vip_2 {{ content.text || '' }}
      .img-container( v-if="content.imageUrl")
        img.message-img(:src="content.imageUrl" @load="loadImg")
      .divider
      .account
        img.avatar(:src="data.image" v-if="data.image")
        div.defaultAvatar(v-else)
        span.accountName.color_text_2 {{ data.accountName || '' }}
</template>
<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {

    };
  },
  computed: {
    formatedTime() {
      const { time } = this.data;
      const date = new Date(time);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      const now = new Date();

      const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

      const showYear = new Date().getFullYear() !== year;
      const isYesterday = yesterday.getFullYear() === year && yesterday.getMonth() + 1 === month && yesterday.getDate() === day;
      const isToday = now.getFullYear() === year && now.getMonth() + 1 === month && now.getDate() === day;

      if (isToday) {
        return '今天';
      }

      if (isYesterday) {
        return '昨天';
      }

      if (showYear) {
        return `${year}年${month}月${day}日`;
      }

      return `${month}月${day}日`;
    },
    content() {
      if (!this.data.content) {
        return {};
      }
      try {
        return JSON.parse(this.data.content);
      } catch (e) {
        console.log(e);
        return {};
      }
    },
  },
  methods: {
    loadImg() {
      this.$emit('loadImg');
    },
    goToOutlink(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="stylus" scoped>
.message-item-container
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  *
    box-sizing: border-box;
  .time
    font-size: 12px;
    line-height: 12px;
  .message-item
    width: 100%;
    border-radius: 8px;
    position: relative;
    margin-top: 12px;
    margin-bottom: 20px;
    .message-header
      display: flex;
      padding: 8px 8px 8px 12px;
      position: relative;
      .ic_svip
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 4px;
      .title
        font-size: 16px;
        line-height: 19px;
        font-weight: 600;
        vertical-align: bottom;
      .outlink
        position: absolute;
        right: 8px;
        top: 10px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        span
          font-size: 12px;
          line-height: 18px;
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        .ic_arrow
          display: inline-block;
          width: 12px;
          height: 12px;
    .message-content
      border-radius: 8px;
      padding-bottom: 12px;
      p
        width: 100%;
        height: auto;
        padding: 12px;
        font-size: 12px;
        line-height: 150%;
      .img-container
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      .message-img
        width: calc(100% - 24px);
        height: 102px;
        border-radius: 8px;
        object-fit: cover;
      .divider
        width: calc(100% - 24px);
        margin: 0 auto 10px;
        height: 0;
      .account
        display: flex;
        align-items: center;
        padding: 0 12px;
        .avatar, .defaultAvatar
          width: 16px;
          height: 16px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 4px;
        .accountName
          font-size: 12px;
.light
  .message-item-container
    .time
      color: #939599;
    .message-item
      background: radial-gradient(176% 127% at 28% -1%, rgba(255,210,168,0.39) 0%, rgba(255,210,168,0.39) 27%, rgba(255,229,206,0.00) 100%), radial-gradient(113% 81% at -40% 136%, #FFD8B4 0%, rgba(255,229,163,0.00) 100%), #FFF6F5;
      .outlink .ic_arrow
        background: no-repeat center / 100% url('~@/assets/imgs/vip/ic_message_link.png');
      .ic_svip
        background: no-repeat center / 100% url('~@/assets/imgs/vip/ic_svip.png');
      .title
        background: linear-gradient(170deg, rgba(255,107,107,0.20) 10%, rgba(255,107,107,0.20) 16%, rgba(0,0,0,0.00) 69%), #4D2000;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      .message-content
        background-color: rgba(255, 255, 255, 0.5);
        .divider
          border-top: 1px dashed rgba(252, 205, 162, 0.4);
        .defaultAvatar
          background: no-repeat center / 100% url('~@/assets/imgs/vip/avatar_svip.png');
</style>
